import { render, staticRenderFns } from "./CMBankAccountsPage.vue?vue&type=template&id=2effd894&"
import script from "./CMBankAccountsPage.vue?vue&type=script&lang=js&"
export * from "./CMBankAccountsPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\wamp64\\www\\corpmessengerwebapp_rtp\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2effd894')) {
      api.createRecord('2effd894', component.options)
    } else {
      api.reload('2effd894', component.options)
    }
    module.hot.accept("./CMBankAccountsPage.vue?vue&type=template&id=2effd894&", function () {
      api.rerender('2effd894', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/bankAccounts/CMBankAccountsPage.vue"
export default component.exports